<template>
  <div class="search-form">
    <el-row>
      <span class="mr-2">创建时间</span>
      <el-date-picker
        v-model="pushTimeValue"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
      >
      </el-date-picker>
      <el-input
        v-model="form.keyword"
        @keyup.enter.native="query"
        placeholder="ERP订单号/客户名称 搜索..."
        clearable
        style="width:300px"
        class="ml-2"
      >
      </el-input>
      <el-button type="primary" @click="query" class="ml-2">查询</el-button>
      <el-button @click="openAdvqueryDialog">高级搜索</el-button>
    </el-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="135px"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="行状态">
              <el-checkbox-group v-model="form.lineStatusList">
                <el-checkbox label="N">新建</el-checkbox>
                <el-checkbox label="Y">处理成功</el-checkbox>
                <el-checkbox label="F">处理失败</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传信息状态">
              <el-checkbox-group v-model="form.uploadStatusList">
                <el-checkbox label="N">待上传</el-checkbox>
                <el-checkbox label="Y">上传成功</el-checkbox>
                <el-checkbox label="F">上传失败</el-checkbox>
                <el-checkbox label="">未处理</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户">
              <dict-select
                v-model="form.custCodeList"
                url="/master/customer/info/select"
                placeholder="请选择客户"
                filterable
                clearable
                style="width:100%"
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="ERP订单号">
              <el-input
                v-model.trim="form.erpOrderNo"
                placeholder="请输入ERP订单号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="上传处理起始时间">
              <el-date-picker
                style="width:100%"
                v-model="form.uploadTimeBegin"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择上传处理起始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上传处理结束时间">
              <el-date-picker
                style="width:100%"
                v-model="form.uploadTimeEnd"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择上传处理结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="修改起始时间">
              <el-date-picker
                style="width:100%"
                v-model="form.updatedTimeBegin"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择修改起始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改结束时间">
              <el-date-picker
                style="width:100%"
                v-model="form.updatedTimeEnd"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择修改结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from '@/libs/util.date'

// 初始表单
const initForm = {
  keyword: '',
  lineStatusList: [],
  uploadStatusList: [],
  custCodeList: [],
}
export default {
  data() {
    const pickerFormat = (picker, beforeDays, baseDays) => {
      const now = baseDays || dayjs()
      let before = now
      if (beforeDays) {
        before = before.subtract(beforeDays, 'days')
      }
      picker.$emit('pick', [before.startOf('date'), now.endOf('date')])
    }
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      selectTransportMode: { type: 'transportMode' },
      selectOrderType: { type: 'orderType' },
      selectBizType: { type: 'bizType' },
      pushTimeValue: [dayjs().startOf('days'), dayjs().endOf('days')],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: (picker) => pickerFormat(picker),
          },
          {
            text: '昨天',
            onClick: (picker) =>
              pickerFormat(picker, 0, dayjs().subtract(1, 'days')),
          },
          {
            text: '最近两天',
            onClick: (picker) => pickerFormat(picker, 1),
          },
          {
            text: '最近7天',
            onClick: (picker) => pickerFormat(picker, 6),
          },
          {
            text: '最近30天',
            onClick: (picker) => pickerFormat(picker, 29),
          },
        ],
      },
    }
  },
  created() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const data = {
        ...this.form,
      }
      if (this.pushTimeValue && this.pushTimeValue.length > 0) {
        data.creationTimeBegin = dayjs(this.pushTimeValue[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        data.creationTimeEnd = dayjs(this.pushTimeValue[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      this.$emit('query', data)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
      this.pushTimeValue = [dayjs().startOf('days'), dayjs().endOf('days')]
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
